import React, { Fragment } from 'react';
import { Pen } from '../icons';
import { t } from '../../i18n';
import { Bdi, screenDir, textDir } from '../../i18n/direction';

const fillClass = card => `fill${card.written ? ' fill-written' : ''}`

// Question text with answer cards dropped into its XXXXX blanks; answers beyond the blanks are listed under it.
// Written answers get a dashed underline, and with handTag the judge's "written by hand" tag.
// The card reads in the direction of its own words outside the blanks (none: the screen's); each answer is isolated,
// and the tag and the blank's name follow the screen.
export function CardText({ question, answers = [], handTag = false, tag: Tag = 'p' }) {
  const parts = question.split('XXXXX')
  const extra = answers.slice(parts.length - 1)
  const dir = textDir(parts.join(''))
  const tagFor = card => handTag && card.written && <> <span className="hand-tag" dir={screenDir()}><Pen size={12} width={2.6} />{t('game.handWritten')}</span></>
  return (
    <>
      <Tag className="bc-text" dir={dir}>
        {parts.map((part, i) => (
          <Fragment key={i}>
            {part}
            {i < parts.length - 1 && (answers[i]
              ? <><Bdi className={fillClass(answers[i])}>{answers[i].text}</Bdi>{tagFor(answers[i])}</>
              : <span className="blank" dir={screenDir()} aria-label={t('game.blank')}></span>)}
          </Fragment>
        ))}
      </Tag>
      {extra.length > 0 &&
        <ul className="answers-list" dir={dir}>{extra.map((a, i) => <li key={i} className={fillClass(a)}><Bdi>{a.text}</Bdi>{tagFor(a)}</li>)}</ul>}
    </>
  )
}

export function CardFoot({ pick }) {
  if (!pick) return null
  return (
    <div className="bc-foot">
      <span className="pick" aria-label={t('game.answersNeeded', { count: pick })}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true"><rect x="4" y="6" width="11" height="15" rx="2"></rect><path d="M9 3h9a2 2 0 0 1 2 2v12"></path></svg>{pick}</span>
    </div>
  )
}
